export const sorting = {
    0: "device.details.name",
    1: "device.details.model",
    2: "device.status.status"
}